export default {
    name: 'mine/about',
    path: 'about',
    component: () => import('./Root.vue')
}